import styled from "styled-components";
import { device } from "../../themes/Breakpoints";

export const TeamListWrap = styled.section`
  max-width: 840px;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 35px 14px 24px 14px;
  margin-top: 32px;
  margin-bottom: 43px;
  & .team img {
    width: 80px;
    height: 80px;
  }
  & .team h2 {
    font-weight: 400;
    font-size: 40px;
    line-height: 60px;
  }
  @media only screen and (max-width: 1249px) {
    margin-bottom: 20px;
  }
  @media only screen and (max-width:767px) {
    & .team img {
      width: 60px;
      height:60px;
    }
    & .team h2 {
      font-size: 32px;
      line-height: 40px;
    }
  }
  @media ${device.mobileM} {
    padding: 14px 14px 14px 14px;
  }
  @media ${device.mobileS} {
    padding: 14px 14px 14px 14px;
  }
`;